import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { GoogleMaps, Maps } from "../../../Constant";
import BasicMap from "./BasicMap";
import MarkerMapComp from "./MarkerMapComp";
import PolygonsComp from "./PolygonsComp";
import PolylinesMapComp from "./PolylinesMapComp";

const GoogleMapContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={GoogleMaps} parent={Maps} title={GoogleMaps} />
      <Container fluid>
        <Row>
          <BasicMap />
          <MarkerMapComp />
          <PolygonsComp />
          <PolylinesMapComp />
        </Row>
      </Container>
    </>
  );
};

export default GoogleMapContainer;
